<template>
  <div class="col-span-full flex flex-col items-center">
    <div class="w-[400px] max-w-full rounded-[10px] border border-[#E9E9E9] bg-white">
      <div class="verify__header">
        <h1 class="verify__title">
          <span v-if="!!updateDone">Bekräfta din e-postadress</span>
          <span v-else-if="!code && !!email">Välj en ny e-postadress</span>
          <span v-else-if="!code && !email">Välj en e-postadress</span>
          <span v-else-if="device=='Same'">BankID på denna enhet </span>
          <span v-else-if="device=='Other'">BankID på annan enhet</span>
          <span v-else>Uppdatera din e-postadress</span>
        </h1>

      </div>
    <div class="verify__preamble" v-if="!message && !device && !showAuthenticationError">
      <p>För att uppdatera din e-postadress som är kopplat till Mina sidor behöver du legitimera dig med BankID.</p>
    </div>
    <div class="verify__wrapper">
      <div v-if="!code && !showAuthenticationError" style="max-width:100%;" class="verify__logo flex flex-col items-center">
        <img
          src="https://tstabgmypagescode.blob.core.windows.net/public/drop/static/images/BankID_logo.png"
        />
        <p id="message" class="text-center" v-if="!!message" v-html="message"></p>
        <p v-else-if="!showAuthenticationError" class="verify__bankid-info">Välj BankID-legitimering</p>
      </div>
      <div v-if="device && !status && !pendingLogin && !code"></div>
      <div v-if="!code">
        <p v-if="status" class="text-center" v-html="status" id="status"></p>
        <div v-if="showAuthenticationError" class="unknown-user">
          <p class="formerror">
            Du finns för närvarande inte registrerad som användare hos oss.
          </p>
          <p>Om du inte har ett konto hos oss kan du enkelt registrera dig hos oss och börja samla köpoäng.</p>
          <a href="/mina-sidor/#/register" class="btn btn--secondary">Registrera dig</a>
        </div>
        <p
          v-if="!!forbiddenMessage"
          class="login-error-message help"
        >{{ forbiddenMessage }}</p>
        <div v-if="!status && !pendingLogin && !forbiddenMessage && !showAuthenticationError">
          <div class="verify__btnWrapper">
            <Button type="primary" id="loginBtnSameDevice" @click="code = null; sameDevice(false)">BankID på denna enhet</Button>
            <Button type="primary"  id="loginBtn" @click="otherDevice(false)">Bank ID med QR-kod</Button>
          </div>
        </div>
        <div v-if="!status && pendingLogin && !forbiddenMessage && !showAuthenticationError">
          <p v-if="isAndroidBrowser" v-html="this.$store.getters.webapp_config.msg.samsungbrowser"></p>
          <SVGImage v-if="device === 'other'" :svg-content="qrCodeSvg" id="svg"></SVGImage>
          <div class="verify__btnWrapper verify__btnWrapper--secondary">
            <Button type="secondary" id="loginBtnSameDevice" @click="sameDevice" v-if="device === 'other'">Använd denna enhet istället</Button>
            <Button type="secondary" id="loginBtn" @cßlick="otherDevice" v-if="device === 'same'">Använd en annan enhet istället</Button>
          </div>
        </div>
      </div>
      <div v-if="code">
        <ChangeEmailForm :code="code" :forbiddenMessage="forbiddenMessage" :dataobj="dataobj" :email="email" @emailUpdated="updateDone=true"/>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { LOGIN_METHODS } from "@/config/constants";
import SVGImage from "@/components/login/svgimage";
import axios from "axios";
import BankIdMixin from "@/mixins/bankid";
import ChangeEmailForm from '@/components/change-email-form';
import Button from '@/components/ui/button';

export default {
  components: { SVGImage,ChangeEmailForm, Button },
  mixins: [BankIdMixin],
  data() {
    return {
      updateDone: false,
      status: null,
      userName: null,
      LOGIN_METHODS,
      showLoader: false,
      showAuthenticationError: false,
      handledPostMessage: false,
      validationRules: "required",
      pendingLogin: false,
      message: null,
      forbiddenMessage: null,
      device: null,
      sessionId: this.$route.params.sessionId || null,
    };
  },
  created() {
    this.forSignIn = false;
    const mediaMobile = window.matchMedia("(max-width: 767px)");
    if (mediaMobile.matches && !this.sessionId) {
     // this.sameDevice();
      //return;
    }

    if (this.sessionId) {
      this.device = "same";
      this.startPollingWithoutSignin()
    }
  },
  beforeDestroy() {
    this.cancelRequest();
    document.removeEventListener('visibilitychange', this.handleVisibility);
    this.bankIdAppOpened = false
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.help {
  color: #ff0800;
  font-size: 14px;
}

#message {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  font-size: 1.8rem;
}

#loginBtn {
  margin-bottom: 1.2rem;
}

#status {
  margin-bottom: 2.4rem;
  font-size: 1.8rem;
}

#svg {
  width: 196px;
  height: auto;
  margin: 0 auto 24px auto;
}

#loginBtnSameDevice {
  margin-bottom: 1.2rem;
  margin-left: 0;
}

.btn--secondary {
  border: solid 2px $abgblue !important;
  background-color: $backgroundcolorwhite !important;
  color: $abgblue !important;

  &:hover, &:active, &:focus {
    background-color: $offwhite;
    border: solid 2px $abghoverblue !important;
    color: $abghoverblue !important;
  }
}

.verify {

  &__wrapper {
    padding: 16px 16px;
  }

  &__header {
    border-bottom: 1px solid $lightgray;
  }

  &__title {
    text-align: left;
    font-size: 2rem;
    font-weight: 700;
    padding: 16px 16px;

    @media (min-width: 800px) {
      font-size: 2.2rem;
    }
  }

  &__preamble p {
    padding: 16px 16px 0 16px;
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    text-align: left;
  }

  &__logo {
    margin-top: 16px;
    margin-bottom: 8px;
  }

  &__bankid-info {
    margin: 10px 0 16px;
    font-size: 1.8rem;
    color: #000;
  }

  &__btnWrapper {
    display: flex;
    flex-direction: column;

    button {
      margin: 0 auto !important;
      display: flex;
      justify-content: center;
      padding: 15px 28px;
      width: 100%!important;
      font-size: 1.6rem !important;
      line-height: 1.4;
    }
    #loginBtn {
      margin-top: 16px !important;
    }

    &--secondary {
      button {
        margin-top: 24px !important;
      }
    }
  }

  .unknown-user {
    text-align: left;
    display: flex;
    flex-direction: column;

    .btn {
      font-size: 1.6rem;
      margin-top: 16px;
      width: 100% !important;
      display: flex;
      justify-content: center;
    }
  }

}
</style>
